import { z } from "zod"

// Version 1 ---------------------
export const ContainerOptionsV1 = z.object({
  backgroundColor: z.string(),
  backgroundImage: z.string(),
  backgroundOpacity: z.number().int().or(z.number()),
  badge: z.union([z.literal(true), z.literal(false)]),
  bleed: z.union([z.literal(true), z.literal(false)]),
  bleedBackground: z.union([z.literal(true), z.literal(false)]),
  bleedBottom: z.union([z.literal(true), z.literal(false)]),
  blur: z.union([z.literal(true), z.literal(false)]),
  card: z.union([z.literal(true), z.literal(false)]),
  cardRadius: z.string(),
  cover: z.union([z.literal(true), z.literal(false)]),
  extraLightBleed: z.union([z.literal(true), z.literal(false)]),
  fullHeight: z.union([z.literal(true), z.literal(false)]),
  fullWidth: z.union([z.literal(true), z.literal(false)]),
  heavyPadding: z.union([z.literal(true), z.literal(false)]),
  height: z.string(),
  inset: z.union([z.literal(true), z.literal(false)]),
  light: z.union([z.literal(true), z.literal(false)]),
  lightBleed: z.union([z.literal(true), z.literal(false)]),
  lightMargin: z.union([z.literal(true), z.literal(false)]),
  lightPadding: z.union([z.literal(true), z.literal(false)]),
  noBackground: z.union([z.literal(true), z.literal(false)]),
  noMargin: z.union([z.literal(true), z.literal(false)]),
  noPadding: z.union([z.literal(true), z.literal(false)]),
  noTopPadding: z.union([z.literal(true), z.literal(false)]),
  showDivider: z.union([z.literal(true), z.literal(false)]),
  style: z.string(),
  textAlign: z.string(),
  textColor: z.string(),
  width: z.string(),
})

export type TContainerOptionsV1 = z.infer<typeof ContainerOptionsV1>

export const ChildrenContainerOptionsV1 = z.object({
  cover: z.union([z.literal(true), z.literal(false)]),
  noMargin: z.union([z.literal(true), z.literal(false)]),
  noBackground: z.union([z.literal(true), z.literal(false)]),
  width: z.string(),
  fullWidth: z.union([z.literal(true), z.literal(false)]),
  height: z.string(),
  fullHeight: z.union([z.literal(true), z.literal(false)]),
  style: z.string(),
})

export type TChildrenContainerOptionsV1 = z.infer<typeof ChildrenContainerOptionsV1>

// Latest ---------------------
export const ContainerOptions = ContainerOptionsV1
export type TContainerOptions = TContainerOptionsV1
export const ChildrenContainerOptions = ChildrenContainerOptionsV1
export type TChildrenContainerOptions = TChildrenContainerOptionsV1
